class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('#search');
    this.backdrop = this.querySelector('[data-predictive-backdrop]')
    this.predictiveSearchContainer = this.querySelector('[data-predictive-container]');
    this.predictiveSearchResults = this.querySelector("[data-predictive-result]")
    this.form = this.querySelector("form")

    this.toolTip = this.querySelector(".tooltip")

    this.form.addEventListener("submit", (event) => event.preventDefault())

    this.backdrop.addEventListener('click', (event) => {
      this.close()
    })

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.input.addEventListener('focus', this.debounce((event) => {
      if (this.input.value) this.open()
    }, 300).bind(this))
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      if (this.predictiveSearchResults.innerHTML) this.predictiveSearchResults.innerHTML = ''
      if (this.toolTip.classList.contains("hideFirstIcon")) this.toolTip.classList.remove("hideFirstIcon")
      this.close();
      return;
    }

    if (!this.toolTip.classList.contains("hideFirstIcon")) this.toolTip.classList.add("hideFirstIcon")
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const hiddenInputs = this.querySelectorAll('input[type="hidden"]')
    let qParams = ''
    hiddenInputs.forEach(hiddenInput => {
      qParams += `&resources${hiddenInput.name}=${hiddenInput.value}`
    })

    fetch(`/search/suggest.json?q=${searchTerm}${qParams}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.json()
      })
      .then((data) => {
        /**
         * data = {
         *  resources: {
         *    results: {
         *      articles: Articles[]
         *    }
         *  }
         * }
         * 
         * Articles = {
         *  author: string,
         *  body: string ( html ),
         *  handle: string,
         *  id: number,
         *  image: string,
         *  published_at: string ( Date ),
         *  summary_html: string,
         *  tags: string[],
         *  title: string,
         *  url: string,
         *  featured_image: Object (ignore this),
         * }
         */

        const articles = data?.resources?.results?.articles
        const map = new Map()

        for (const article of articles) {
          const _article = map.get(article.title)
          if (_article && (_article.title === article.title)) {
            if (new Date(_article.published_at) < new Date(article.published_at)) {
              map.set(article.title, article)
            }
          } else {
            map.set(article.title, article)
          }
        }

        const _articles = Array.from(map.values())

        let el;
        if (_articles.length === 0) {
          el = document.createElement('div')
          el.textContent = "No articles found"
        } else {
          el = document.createElement('ul')
          el.id = "predictive-search-results-pages-list-mobile"
          el.classList.add("predictive-search__results-list")
          el.role = "group"
          el.ariaLabel = "predictive-search-pages-mobile"

          for (const article of _articles) {
            const li = document.createElement('li')
            li.id = 'predictive-search-option-article-mobile-{{ forloop.index }}'
            li.role = 'option'
            li.ariaSelected = 'false'
            li.innerHTML = `
            <a href="${article.url}" class="flex gap-2" tabindex="-1">
              <div class="relative">
                <img
                  src="${article.featured_image.url || article.image}"
                  alt="${article.featured_image.alt || 'The featured image for this article'}"
                  class="predictive-search-image w-full h-full absolute inset-0 object-cover object-center"
                  width="300"
                  height="300" 
                />
              </div>
              <div class="predictive-search__item-content predictive-search__item-content--centered">
                <p class="predictive-search__item-heading ">${article.title.trim()}</p>
              </div>
            </a>
            `

            el.appendChild(li)
          }
        }

        // Make sure to get rid of old html
        this.predictiveSearchResults.replaceChildren(el)
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchContainer.style.display = 'flex';
    this.backdrop.style.display = 'block';
  }

  close() {
    this.predictiveSearchContainer.style.display = 'none';
    this.backdrop.style.display = '';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
